import React from "react";
import isUrl from "is-url";
import { Container, Header, Columns, Details, Link } from "./styled/listing-details";
function ListingDetails(_a) {
    var details = _a.details;
    return (React.createElement(Container, null,
        React.createElement(Header, null, "Details"),
        React.createElement(Columns, null, details.map(function (_a, index) {
            var field = _a.field, value = _a.value;
            return (React.createElement(Details, { key: index },
                React.createElement("strong", null,
                    field,
                    ":"),
                " ",
                isUrl(value) ? (React.createElement(Link, { href: value, target: "_blank", rel: "noopener noreferrer" }, "View")) : (value)));
        }))));
}
export default ListingDetails;
